import API from "../../../utils/api";

export const getShopifySalesChannelApi = async (filters) => {
  const response = await API.get("settings/shopify-sales-channel", { params: filters });
  return { response };
};

export const addShopifySalesChannelApi = async (data) => {
  const response = await API.post("settings/shopify-sales-channel", data);
  return { response };
};

export const updateShopifySalesChannelApi = async (data, id) => {
  const response = await API.put(`settings/shopify-sales-channel/${id}`, data);
  return { response };
};

export const deleteShopifySalesChannelApi = async (id) => {
  const response = await API.delete(`settings/shopify-sales-channel/${id}`);
  return { response };
};
